/*
 * PRIMO EUROPA — Marco compartido de comparadores
 *
 * Principio: .primo-custom-layout nunca se modifica. Contiene el comparador
 * original (cabecera, situación y tres ofertas). La home se replica arriba
 * con su mismo contenido y sus mismos selectores; abajo se añade el cierre
 * de la home a ancho completo.
 */
(function () {
    'use strict';

    if (window.__PRIMO_COMPARATOR_FRAME_LOADED__) return;
    window.__PRIMO_COMPARATOR_FRAME_LOADED__ = true;

    var ROUTES = {
        '/mejor-cuenta-bancaria-para-extranjeros-en-espana/': true,
        '/mejor-cuenta-bancaria-para-extranjeros-en-alemania/': true,
        '/mejor-plataforma-para-buscar-piso-en-espana/': true,
        '/mejor-plataforma-para-buscar-piso-en-alemania/': true,
        '/mejor-operador-de-movil-para-expats-en-espana/': true,
        '/mejor-operador-de-movil-para-expats-en-alemania/': true,
        '/mejor-seguro-de-salud-para-recien-llegados-a-espana/': true,
        '/mejor-seguro-de-salud-para-expats-en-alemania/': true,
        '/mejor-app-para-hacer-la-declaracion-de-la-renta-en-espana/': true,
        '/mejor-app-para-hacer-la-declaracion-de-impuestos-en-alemania/': true,
        '/mejor-seguro-de-viaje-para-visitar-europa-desde-latam/': true,
        '/mejor-herramienta-para-crear-un-cv-europeo-ats-friendly/': true,
        '/mejor-servicio-de-traduccion-jurada-oficial-en-europa/': true,
        '/como-homologar-tu-titulo-universitario-en-europa/': true,
        '/mejor-servicio-de-envio-de-paquetes-a-latam-desde-europa/': true,
        '/mejor-app-para-enviar-dinero-a-latam-desde-europa/': true,
        '/mejor-curso-de-aleman-online-con-certificado/': true,
        '/mejor-curso-de-ingles-y-frances-online-con-profesores-nativos/': true,
        '/mejor-tarjeta-para-viajar-sin-comisiones-por-el-mundo/': true,
        '/mejor-vpn-para-ver-tv-y-bancos-de-latam-desde-europa/': true
    };

    var GERMANY = {
        antes: [
            ['🔑', 'Buscar Alquiler', '/mejor-plataforma-para-buscar-piso-en-alemania/'],
            ['🏥', 'Seguro Médico', '/mejor-seguro-de-salud-para-expats-en-alemania/'],
            ['✈️', 'Viajar Seguro', '/mejor-seguro-de-viaje-para-visitar-europa-desde-latam/'],
            ['📄', 'Armar tu CV', '/mejor-herramienta-para-crear-un-cv-europeo-ats-friendly/'],
            ['📝', 'Traducciones', '/mejor-servicio-de-traduccion-jurada-oficial-en-europa/'],
            ['🎓', 'Validar Títulos', '/como-homologar-tu-titulo-universitario-en-europa/']
        ],
        semana: [
            ['🏦', 'Abrir Cuenta', '/mejor-cuenta-bancaria-para-extranjeros-en-alemania/'],
            ['📱', 'Tu Celular', '/mejor-operador-de-movil-para-expats-en-alemania/']
        ],
        vida: [
            ['📦', 'Enviar Cajas', '/mejor-servicio-de-envio-de-paquetes-a-latam-desde-europa/'],
            ['💸', 'Remesas a Casa', '/mejor-app-para-enviar-dinero-a-latam-desde-europa/'],
            ['📊', 'Taxes e Impuestos', '/mejor-app-para-hacer-la-declaracion-de-impuestos-en-alemania/'],
            ['🗣️', 'Aprender Idioma', '/mejor-curso-de-aleman-online-con-certificado/'],
            ['📺', 'TV de tu País', '/mejor-vpn-para-ver-tv-y-bancos-de-latam-desde-europa/'],
            ['💳', 'Tarjetas Globales', '/mejor-tarjeta-para-viajar-sin-comisiones-por-el-mundo/']
        ]
    };

    var SPAIN = {
        antes: [
            ['🔑', 'Buscar Alquiler', '/mejor-plataforma-para-buscar-piso-en-espana/'],
            ['🏥', 'Seguro Médico', '/mejor-seguro-de-salud-para-recien-llegados-a-espana/'],
            ['✈️', 'Viajar Seguro', '/mejor-seguro-de-viaje-para-visitar-europa-desde-latam/'],
            ['📄', 'Armar tu CV', '/mejor-herramienta-para-crear-un-cv-europeo-ats-friendly/'],
            ['📝', 'Traducciones', '/mejor-servicio-de-traduccion-jurada-oficial-en-europa/'],
            ['🎓', 'Validar Títulos', '/como-homologar-tu-titulo-universitario-en-europa/']
        ],
        semana: [
            ['🏦', 'Abrir Cuenta', '/mejor-cuenta-bancaria-para-extranjeros-en-espana/'],
            ['📱', 'Tu Celular', '/mejor-operador-de-movil-para-expats-en-espana/']
        ],
        vida: [
            ['📦', 'Enviar Cajas', '/mejor-servicio-de-envio-de-paquetes-a-latam-desde-europa/'],
            ['💸', 'Remesas a Casa', '/mejor-app-para-enviar-dinero-a-latam-desde-europa/'],
            ['📊', 'Taxes e Impuestos', '/mejor-app-para-hacer-la-declaracion-de-la-renta-en-espana/'],
            ['🗣️', 'Aprender Idioma', '/mejor-curso-de-ingles-y-frances-online-con-profesores-nativos/'],
            ['📺', 'TV de tu País', '/mejor-vpn-para-ver-tv-y-bancos-de-latam-desde-europa/'],
            ['💳', 'Tarjetas Globales', '/mejor-tarjeta-para-viajar-sin-comisiones-por-el-mundo/']
        ]
    };

    var COLLECTIONS = {alemania: GERMANY, espana: SPAIN};
    var PHASE_KEYS = {antes: 'antes', semana: 'semana', vida: 'vida'};

    function pagePath() {
        var previewPath = document.body && document.body.getAttribute('data-primo-comparator-path');
        var path = previewPath || window.location.pathname || '/';
        return path.endsWith('/') ? path : path + '/';
    }

    function cardsMarkup(cards) {
        return '<div class="pe-accordion-grid">' + cards.map(function (card) {
            return '<a href="' + card[2] + '#primo-comparador" class="pe-accordion-card"><i>' + card[0] + '</i><strong>' + card[1] + '</strong></a>';
        }).join('') + '</div>';
    }

    function buildTop() {
        var headerTemplate = document.getElementById('primo-comparator-header-template');
        if (!headerTemplate) return null;

        var wrapper = document.createElement('div');
        wrapper.id = 'pe-comparator-top-frame';
        wrapper.className = 'pe-comparator-frame pe-comparator-frame-top';
        wrapper.innerHTML = headerTemplate.innerHTML.trim() +
            '<section class="pe-hero pe-hero-rebuild">' +
                '<div class="pe-hero-orbit pe-hero-orbit-top" aria-hidden="true"></div><div class="pe-hero-orbit pe-hero-orbit-bottom" aria-hidden="true"></div>' +
                '<div class="pe-container pe-hero-grid pe-hero-grid-rebuild"><div class="pe-hero-copy">' +
                    '<p class="pe-eyebrow"><span></span> HISPANOS · ESPAÑA Y ALEMANIA</p>' +
                    '<h1>El sistema europeo es un<br>laberinto burocrático<br><em>Nosotros te damos el atajo directo</em></h1>' +
                    '<div class="pe-hero-actions"><a class="pe-button pe-button-coral" href="#rutas">Encontrar mi ruta <span>→</span></a></div>' +
                '</div><div class="pe-hero-panel pe-hero-panel-large" aria-label="Resumen de la ruta de llegada">' +
                    '<div class="pe-panel-top"><span>MI RUTA EUROPEA</span><span>01 / 03</span></div><div class="pe-panel-title">Llegar bien<br><strong>cambia todo</strong></div>' +
                    '<div class="pe-panel-line"><i class="is-active"></i><b></b><i></i><b></b><i></i></div><div class="pe-panel-labels"><span>Antes</span><span>Llegada</span><span>Establecerte</span></div><span class="pe-panel-mark" aria-hidden="true">PE</span>' +
                '</div></div>' +
            '</section>' +
            '<section class="pe-workflow" id="rutas"><div class="pe-container pe-workflow-grid">' +
                '<aside class="pe-workflow-steps" aria-label="Pasos de la ruta"><div class="pe-workflow-step is-active"><b>1</b><span>Elige tu país</span></div><div class="pe-workflow-line"></div><div class="pe-workflow-step"><b>2</b><span>Abre tu fase</span></div><div class="pe-workflow-line"></div><div class="pe-workflow-step"><b>3</b><span>Elige la<br>opción top</span></div></aside>' +
                '<div class="pe-workflow-main"><div class="pe-workflow-heading"><p class="pe-eyebrow pe-eyebrow-dark"><span></span> RUTA EUROPEA</p><h2>Nuestra misión: <em>Orientarte en la burocracia europea</em></h2><p>Reunimos servicios de vivienda, banca, seguros y movilidad que puedes comparar según tu situación. Revisa siempre las condiciones del proveedor antes de contratar.</p></div>' +
                '<div class="pe-country-grid pe-country-grid-workflow" role="tablist" aria-label="País de destino">' +
                    '<button class="pe-country-card" type="button" data-country="espana" role="tab" aria-selected="false"><span class="pe-country-flag pe-country-flag-es" aria-label="España"><b></b><i></i><em></em></span><strong>España</strong></button>' +
                    '<button class="pe-country-card is-active" type="button" data-country="alemania" role="tab" aria-selected="true"><span class="pe-country-flag pe-country-flag-de" aria-label="Alemania"><b></b><i></i><em></em></span><strong>Alemania</strong></button>' +
                '</div>' +
                '<div class="pe-phase-accordion" aria-label="Fase de llegada">' +
                    '<article class="pe-phase-item is-open" data-phase="antes"><button class="pe-phase-trigger" type="button" aria-expanded="true"><span class="pe-phase-icon">🛫</span><span><strong>Antes de llegar</strong><small>Prepara todo desde casa</small></span><i>⌄</i></button><div class="pe-phase-panel" role="region" aria-label="Opciones antes de llegar"><div class="pe-phase-panel-content"></div></div></article>' +
                    '<article class="pe-phase-item" data-phase="semana"><button class="pe-phase-trigger" type="button" aria-expanded="false"><span class="pe-phase-icon">🏠</span><span><strong>Primera semana</strong><small>Lo urgente al aterrizar</small></span><i>⌄</i></button><div class="pe-phase-panel" role="region" aria-label="Opciones para la primera semana"><div class="pe-phase-panel-content"></div></div></article>' +
                    '<article class="pe-phase-item" data-phase="vida"><button class="pe-phase-trigger" type="button" aria-expanded="false"><span class="pe-phase-icon">🧾</span><span><strong>Ya instalado</strong><small>Para el día a día</small></span><i>⌄</i></button><div class="pe-phase-panel" role="region" aria-label="Opciones tras instalarte"><div class="pe-phase-panel-content"></div></div></article>' +
                '</div><p class="pe-workflow-note">Abre una fase para ver las opciones ya comparadas para ese momento del viaje.</p></div>' +
            '</div></section>';
        return wrapper;
    }

    function buildBottom() {
        var wrapper = document.createElement('div');
        wrapper.id = 'pe-comparator-bottom-frame';
        wrapper.className = 'pe-comparator-frame pe-comparator-frame-bottom';
        wrapper.innerHTML =
            '<section class="pe-resource"><div class="pe-container pe-resource-card"><div class="pe-resource-seal"><span>DE</span><small>RUTA<br>EUROPEA</small></div><div><p class="pe-eyebrow">RECURSOS PARA EMPEZAR</p><h2>Evita perder dinero al <em>emigrar</em></h2><p>Recibe una guía práctica para ordenar los primeros trámites y saber qué preguntar antes de tomar decisiones.</p></div><a class="pe-button pe-button-light" href="#/portal/signup" data-portal="signup">Quiero la guía gratis <span>→</span></a></div></section>' +
            '<div class="pe-legal-close" role="contentinfo"><div class="pe-container"><div class="pe-footer-links"><a href="/sobre-nosotros/">Sobre nosotros</a><a href="/aviso-legal-impressum/">Aviso Legal</a><a href="/politica-de-privacidad/">Política de Privacidad</a><a href="/politica-de-cookies/">Política de Cookies</a><button class="primo-consent-trigger primo-consent-trigger--footer" type="button" data-consent-action="open-settings"><svg class="primo-consent-trigger-icon" aria-hidden="true" viewBox="0 0 24 24" focusable="false"><path d="M4 6h7M15 6h5M4 12h3M11 12h9M4 18h9M17 18h3"></path><circle cx="13" cy="6" r="2"></circle><circle cx="9" cy="12" r="2"></circle><circle cx="15" cy="18" r="2"></circle></svg><span>Configurar cookies</span></button></div><small>Los servicios se contratan directamente con proveedores independientes. Primo Europa puede recibir una comisión si utilizas algunos enlaces, sin coste adicional para ti.</small></div></div>';
        return wrapper;
    }

    function wireRoute(top) {
        var country = 'alemania';
        var openPhase = 'antes';
        var phaseItems = Array.prototype.slice.call(top.querySelectorAll('.pe-phase-item'));
        var countryCards = Array.prototype.slice.call(top.querySelectorAll('.pe-country-card'));

        function render() {
            countryCards.forEach(function (card) {
                var active = card.dataset.country === country;
                card.classList.toggle('is-active', active);
                card.setAttribute('aria-selected', String(active));
            });
            phaseItems.forEach(function (item) {
                var active = item.dataset.phase === openPhase;
                item.classList.toggle('is-open', active);
                item.querySelector('.pe-phase-trigger').setAttribute('aria-expanded', String(active));
                item.querySelector('.pe-phase-panel-content').innerHTML = active ? cardsMarkup(COLLECTIONS[country][PHASE_KEYS[openPhase]]) : '';
            });
        }

        countryCards.forEach(function (card) {
            card.addEventListener('click', function () {
                country = card.dataset.country;
                render();
            });
        });
        phaseItems.forEach(function (item) {
            item.querySelector('.pe-phase-trigger').addEventListener('click', function () {
                openPhase = openPhase === item.dataset.phase ? null : item.dataset.phase;
                render();
            });
        });
        render();
    }

    function removeLegacyAfter(main, bottom) {
        var sibling = main.nextElementSibling;
        while (sibling) {
            var next = sibling.nextElementSibling;
            if (sibling !== bottom && (sibling.matches('.gh-container, .gh-footer, footer') || sibling.id === 'primo-testimonials' || sibling.id === 'primo-leadmagnet' || sibling.id === 'primo-legalbar')) sibling.remove();
            sibling = next;
        }
        main.querySelectorAll('.gh-comments').forEach(function (node) { node.remove(); });
    }

    function removeDuplicateClosingFor(path, bottom) {
        if (!ROUTES[path]) return;

        document.querySelectorAll('.primo-legal-close, #primo-leadmagnet, #primo-legalbar').forEach(function (node) {
            if (!bottom.contains(node)) node.remove();
        });
    }

    function insertFrame() {
        // Proyecto Musk usa una plantilla propia: nunca debe recibir el marco heredado de comparadores.
        if (document.querySelector('[data-project-musk-planner]')) return false;

        var path = pagePath();
        var core = document.querySelector('.primo-custom-layout');
        if (!ROUTES[path] || !core || document.getElementById('pe-comparator-top-frame')) return Boolean(core);

        document.body.classList.add('home-template', 'primo-comparator-frame-template');
        var top = buildTop();
        if (!top) return false;
        var bottom = buildBottom();
        var main = core.closest('.gh-main');
        var legacyRoute = document.getElementById('primo-main-interface');
        var viewport = document.querySelector('.gh-viewport');

        if (viewport && legacyRoute && legacyRoute.parentNode === viewport) viewport.insertBefore(top, legacyRoute);
        else if (main) main.parentNode.insertBefore(top, main);
        else core.parentNode.insertBefore(top, core);

        core.insertAdjacentElement('afterend', bottom);

        if (main) removeLegacyAfter(main, bottom);
        removeDuplicateClosingFor(path, bottom);
        wireRoute(top);
        return true;
    }

    function start() {
        var attempts = 0;
        var timer = window.setInterval(function () {
            attempts += 1;
            if (insertFrame() || attempts >= 40) window.clearInterval(timer);
        }, 120);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
    else start();
})();
